import React, { ReactNode } from 'react';
import '../scss/bullet.scss';

interface Props {
  children: ReactNode;
  onClick: () => void;
  isActive: boolean;
}

const Bullet: React.FC<Props> = ({ children, onClick, isActive }) => {
  return (
    <div onClick={onClick} className={isActive ? `bullet active-border` : `bullet`}>
      {children}
    </div>
  );
};

interface BulletContainerProps {
  children: ReactNode;
}

export const BulletContainer: React.FC<BulletContainerProps> = ({ children }) => {
  return (
    <section className="bullets-wrapper">
      <div className="bullets-container">{children}</div>
    </section>
  );
};

export default Bullet;
